import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../components/MainBody/MainBody";
import MainTabList from "../../components/MainBody/MainTabList";
import { useTrust } from "../../lib/context/TrustContext";
import DownloadedABA from "./DownloadedABA";
import GenerateABA from "./GenerateABA";

const tabsKey = [
  {
    name: "Generate .ABA",
    tabName: "generate-aba",
    value: 1,
  },
  {
    name: "Download .ABA file / View History",
    tabName: "download-aba",
    value: 2,
  },
];

const ABATabs = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "generate-aba";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  const { trustId } = useTrust();

  useEffect(() => {
    navigate(
      `/trusts/${trustId}/abas?tab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      }
    );
  }, [activeTab, navigate, trustId]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        mainClassName="w-[calc(100%-3rem)]"
        mainTitle={"Payment Instructions"}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative`}
        >
          {activeTab === 1 ? (
            <GenerateABA />
          ) : activeTab === 2 ? (
            <DownloadedABA />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default ABATabs;
